export const auth_path = '/wp-json/jwt-auth/v1/token';
export const validate_path = '/wp-json/jwt-auth/v1/token/validate';
export const acl_path = '/wp-json/lipus-digitala-hjartat/v1/auth-validate';
export const cookie_name = 'login_hjartat';

const isProd = process.env.NODE_ENV === 'production';

let sessions = {};

export const fetchJson = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Fetch Error: ${error.message}`);
    return { error: error.message };
  }
};

const universalAtob = b64Encoded => {
  try {
    return window.atob(b64Encoded);
  } catch (err) {
    return Buffer.from(b64Encoded, 'base64').toString();
  }
};

export const getUrlBase = origin => {
  return `https://${origin}.lipus${isProd ? '.se' : '.test'}`;
};

export const readToken = token => {
  try {
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const data = JSON.parse(universalAtob(base64));
      return data;
    }
  } catch (error) {
    console.error(error);
  }
};

export async function sessionMiddleware(req, res, next) {
  req.getSession = async () => {
    const token = req.cookies[cookie_name];

    if (!token) {
      return false;
    }

    const tokenData = readToken(token);

    // This is origin to validate against
    if (!tokenData?.iss || !tokenData?.data?.user?.id) {
      return false;
    }

    const {
      iss,
      data: {
        user: { id: userId },
      },
    } = tokenData;
    const unique = `${iss.replace(/[^a-zA-Z]/g, '')}.${userId}`;

    if (sessions.hasOwnProperty(unique)) {
      return true;
    }

    const hosts = [getUrlBase('spurnet'), getUrlBase('kursverktyg')];

    if (hosts.includes(iss) === false) {
      return false;
    }

    const params = {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // Validate token
    let response = await fetchJson(`${iss}${validate_path}`, params);

    const { code, data } = response || {};
    const { status } = data || 500;

    const valid = status === 200 && code === 'jwt_auth_valid_token';

    if (valid) {
      sessions[unique] = tokenData;
    }

    return valid;
  };

  next();
}

export function checkSession() {
  return async (req, res, next) => {
    try {
      const loggedIn = await req.getSession();

      if (!loggedIn) {
        return res.status(403).json({ errors: [{ msg: 'Forbidden' }] });
      }

      return next();
    } catch (error) {
      return next(error);
    }
  };
}
